import { NavLink, Outlet } from 'react-router';
import { useMe } from '../../api/client';
import { Forbidden } from '../ModQueue';

export function AdminLayout() {
  const me = useMe();
  if (me.isPending) return <div className="page muted">Loading...</div>;
  if (me.data?.user?.role !== 'admin') return <Forbidden />;
  const tabs: [string, string][] = [
    ['', 'Overview'],
    ['users', 'Users'],
    ['artifacts', 'Artifacts'],
    ['content', 'Content'],
    ['seed', 'Seed'],
    ['addon', 'Addon uploads'],
    ['builds', 'Builds'],
    ['characters', 'Characters'],
    ['audit', 'Audit log'],
  ];
  return (
    <div className="page">
      <title>Administration</title>
      <h1>Administration</h1>
      <nav
        className="nav-row"
        aria-label="Admin sections"
        style={{ borderTop: '1px solid var(--border)' }}
      >
        <div className="inner" style={{ padding: '4px 0' }}>
          {tabs.map(([path, label]) => (
            <NavLink key={path} to={`/admin/${path}`} end={path === ''}>
              {label}
            </NavLink>
          ))}
        </div>
      </nav>
      <Outlet />
    </div>
  );
}
